import React, { Fragment, useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  getProfileData,
  memberProfileData,
  getUserProfileFormField,
  setProfileProgress,
  setFieldValues,
} from "../../routes/profile/modules/profile";
import { setLoginData } from "../../routes/login/modules/login";
import { getUserPostData } from "../../routes/Post/modules/post";
import logo from "../../assets/images/logo.png";
import homedisable from "../../assets/images/home-disable.svg";
import homeactive from "../../assets/images/home-active.svg";
import memberdisable from "../../assets/images/member.svg";
import memberactive from "../../assets/images/member-active.svg";
import networkdisable from "../../assets/images/network.svg";
import networkactive from "../../assets/images/network_active.svg";
import b2bdisable from "../../assets/images/b2b.svg";
import b2bactive from "../../assets/images/b2b_active.svg";
import recipedisable from "../../assets/images/recipe.svg";
import recipeactive from "../../assets/images/recipeactive.svg";
import marketplacedisable from "../../assets/images/marketplace.svg";
import marketplaceactive from "../../assets/images/marketplace_active.svg";
import userProfile from "../../assets/images/dummy-profile-pic.jpg";
import auth from "../../helpers/auth";
import constant from "../../helpers/constant";
import {
  clearNotification,
  fetchAllNotification,
} from "../../routes/home/modules/HomeModule";
import FormSpinner from "../Spinners/FormSpinner";
import {
  getConnectionData,
  getSelectedHubs,
} from "../../routes/B2B/modules/B2B";
import { slide as Menu } from "react-burger-menu";
import {
  getFAQData,
  getUserSettingData,
} from "../../routes/setting/module/UserSetting";
import firebase from "../../config/firebase";
import language from "../../helpers/language";
import RightFooter from "../Footer/RightFooter";
import Modal from "react-modal";

import {
  setMarketPlaceStoreData,
  checkStoreStatus,
  addProdctToCart,
  verifyCartProducts,
  setMyDashboardStatus,
} from "../../routes/marketplace/modules/marketplace";
import {
  getReviewHubs,
  getStateWiseHubs,
  newHubStateSelected,
  selectedHubsState,
  seletedCityArray,
  seletedCityNameArray,
  seletedStatedArray,
  stateHubSelect,
} from "../../routes/hubs/modules/hubs";
import { getProductDetailsOnType } from "../../routes/marketplace/modules/marketplaceHelper";

export function Header(params) {
  const notificationRef = useRef();
  const profilePopUpRef = useRef();
  const [showProfile, SetshowProfile] = useState(false);
  const [showNotif, SetShowNotif] = useState(false);
  const [alyseiReview, setAlyseiReview] = useState(false);
  const [profilePercentage, setProfilePercentage] = useState();
  const [user, setUser] = useState([]);
  const [allNotificationData, setAllNotificationData] = useState([]);
  const [lastPage, setLastPage] = useState(1);
  const [notificationCount, setNotificationCount] = useState();
  const [userNodeData, setUserNodeData] = useState({});
  const [recentMessageCount, setRecentMessageCount] = useState(0);
  const [declineModal, setDeclineModal] = useState(false);
  const [declineData, setDeclineData] = useState();
  const [lang] = useState(language.getLang());
  const [b2bTitle, setB2bTitle] = useState("B2B");
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const currentUser = JSON.parse(localStorage.getItem("USER_TYPE")) ?? null;
  const { profileData } = useSelector((state) => state.memberProfileData);
  let { cartProducts } = useSelector((state) => state.marketPlaceReducerData);

  const {
    profileProgressData: { data },
  } = useSelector((state) => state.memberProfileData);

  const {
    notificationData,
    getNotificationSpinner,
    get_Subscription_Status_Data,
  } = useSelector((state) => state.activityFeedStatus);

  console.log(notificationData, "notificationdata");

  const subscriptionPlanData =
    get_Subscription_Status_Data?.subscription?.subscription_plan;
  console.log(
    get_Subscription_Status_Data?.connection_request,
    subscriptionPlanData?.b2b_connection_importer,
    "gettt"
  );

  useEffect(() => {
    const allowPages = [
      "/setting",
      "/privacy",
      "/company",
      "/password",
      "/blocking",
      "/setting-membership",
      "/settingbilling",
      "/your-data",
      "/faqs",
    ];
    if (!allowPages.includes(location.pathname)) {
      if (window.Tawk_API) {
        window.Tawk_API.hideWidget();
      }
      return () => {
        if (window.Tawk_API) {
          window.Tawk_API.showWidget();
        }
      };
    }
  }, []);

  useEffect(() => {
    const totalProduct = localStorage.getItem("totalProductInCart")
      ? JSON.parse(localStorage.getItem("totalProductInCart"))
      : [];
    if (
      totalProduct?.length > 0 &&
      ["/marketplace/checkout-form", "/marketplace/my-cart"]?.includes(
        history.location.pathname
      )
    ) {
      verifyCartProductWithServer(totalProduct);
    } else {
      totalProduct?.length > 0 && dispatch(addProdctToCart(totalProduct));
    }
  }, [history.location.pathname]);

  // check your current price of cart item
  const verifyCartProductWithServer = async (cartProducts) => {
    const getValueOnType = getProductDetailsOnType(cartProducts);
    const keys = {
      product_id: getValueOnType("marketplace_product_id") ?? [],
      product_quantity: getValueOnType("count") ?? [],
      offer_id: cartProducts[0]?.map_offer_id ?? [],
    };
    const response = await verifyCartProducts(keys);
    if (response?.success === 200) {
      if (response?.data?.length > 0) {
        const mapDataWithIncoterms = response?.incoterm
          ? response?.data?.map((item, i) =>
              i === 0 ? { ...item, incoterm: response?.incoterm } : item
            )
          : response?.data;
        dispatch(addProdctToCart(mapDataWithIncoterms));
        localStorage.setItem(
          "totalProductInCart",
          JSON.stringify(mapDataWithIncoterms)
        );
      }
    }
  };

  useEffect(() =>{
    const freeCall = async () => {
      //window.fcWidget.hide()
      const user = await auth.getUserType();
      await setUser(JSON.parse(user));
      await dispatch(memberProfileData(history));
      // await dispatch(profileProgress(token));
      setProfilePercentage(localStorage.getItem("profile_percentage"));
      document.body.classList.remove(`hubs`);
    }
    freeCall()
  }, []);

  useEffect(() =>{
    const freeCall = async () => {
      if (profileData?.data?.user_data?.role_id === 10) {
        await setB2bTitle("Hubs");
      }
      await setAllNotificationData(notificationData);
      await setLastPage(notificationData?.last_page);
    }
    freeCall()
  }, [notificationData, profileData]);

  useEffect(()=>{
    const freeCall = async () => {
      await getUserNode();
    }
    freeCall()
  }, [
    profileData?.data?.user_data?.user_id,
    localStorage.getItem("alysei_review"),
  ]);

  // start hanlePop-Up
  useEffect(() => {
    const closeNotificationPopUp = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        SetShowNotif(false);
      }
    };
    document.body.addEventListener("click", closeNotificationPopUp);

    return () =>
      document.body.addEventListener("click", closeNotificationPopUp);
  }, [notificationRef]);

  //  hanleprofilePop-Up
  useEffect(() => {
    const closeProfilePopUp = (event) => {
      if (
        profilePopUpRef.current &&
        !profilePopUpRef.current.contains(event.target)
      ) {
        SetshowProfile(false);
      }
    };
    document.body.addEventListener("click", closeProfilePopUp);
    return () => document.body.addEventListener("click", closeProfilePopUp);
  }, [profilePopUpRef]);
  // End pop-up

  const getUserNode = async () => {
    const userId = await profileData?.data?.user_data?.user_id;
    if (userId) {
      const fetchUserNode = firebase.database().ref("users").child(userId);
      fetchUserNode.on("value", async (snapshot) => {
        const response = snapshot.val();
        console.log(response, "response-Notification notificationCount");
        await setAlyseiReview(response?.alysei_approval);
        await setNotificationCount(response?.notification);
        await setUserNodeData(response);
      });
    }
  };

  console.log(notificationCount, "notificationCount notificationCount");
  useEffect(()=>{
    const freeCall = async () => {
      const userId = await profileData?.data?.user_data?.user_id;
      if (userId) {
        fetchRecentMessage(userId);
      }
    }
    freeCall()
  }, [profileData?.data?.user_data?.user_id]);

  const fetchRecentMessage = (userId) => {
    const userNode = `user_${userId}`;
    let newRecentMessageArr = [];
    let readCount = 0;
    const recentMessageFire = firebase
      .database()
      .ref("RecentMessage")
      .child(userNode);
    recentMessageFire.on("value", async (snapshot) => {
      const response = await snapshot.val();
      for (let id in response)
        newRecentMessageArr.push({ id, ...response[id] });
      newRecentMessageArr?.map((item) => {
        readCount = item?.readCount === 0 ? 0 : readCount + 1;
      });
      setRecentMessageCount(readCount);
    });
  };

  const handleNotification = async () => {
    await dispatch(checkStoreStatus());
    await SetShowNotif(!showNotif);
    SetshowProfile(false);
    await dispatch(fetchAllNotification(1)).then((result) => {
      if (result) {
        if (userNodeData?.notification) {
          userNodeData.notification = 0;
          const userId = profileData?.data?.user_data?.user_id;
          firebase.database().ref("users").child(userId).set(userNodeData);
        }
      }
    });
  };

  const logout = async (action) => {
    auth.removeAccessToken();
    const BannerStatus = localStorage.getItem("BannerStatus");

    localStorage.clear();

    dispatch(addProdctToCart([]));
    await dispatch(setFieldValues({}));
    await dispatch(getProfileData([]));
    await dispatch(setProfileProgress([]));
    await dispatch(getUserPostData([]));
    await dispatch(setLoginData([]));
    await dispatch(getConnectionData([]));
    await dispatch(getSelectedHubs([]));
    await dispatch(getFAQData([]));
    await dispatch(getUserSettingData([]));
    await dispatch(setMarketPlaceStoreData([]));
    await dispatch(getStateWiseHubs([]));
    await dispatch(getReviewHubs([]));
    await dispatch(selectedHubsState([]));
    await dispatch(seletedStatedArray([]));
    await dispatch(stateHubSelect([]));
    await dispatch(seletedCityNameArray([]));
    await dispatch(newHubStateSelected([]));
    await dispatch(seletedCityArray([]));
    await dispatch(getUserProfileFormField([]));

    if (BannerStatus !== null) {
      localStorage.setItem("BannerStatus", BannerStatus);
    }

    localStorage.setItem("lang", "en");
    //history.push('/register');
    history.push("/");
  };

  const removeNotification = async () => {
    await dispatch(clearNotification());
  };

  const redirectTo = (item) => {
    // console.log(
    //   item,
    //   item?.notification_type,
    //   item?.notification_type == 3,
    //   currentUser?.role_id,
    //   "item?.notification_type"
    // );

    item?.notification_type === "progress" && history.push("/profile");
    parseInt(item?.notification_type) === 1 && history.push("/message");

    parseInt(item?.notification_type) === 4 && history.push("/connection");
    parseInt(item?.notification_type) === 5 && history.push("/following");
    parseInt(item?.notification_type) === 9 && history.push("/membership");
    parseInt(item?.notification_type) === 14 &&
      item?.sender_role == 3 &&
      history.push(`${"/marketplace/view-dispute/"}${item?.post_id}`);
    // parseInt(item?.notification_type) === 15 && currentUser?.role_id === 11
    //   ? history.push(`/view-recent-request/${item?.redirect_to_id}`)
    //   : history.push({
    //     pathname: '/marketplace/dashboard',
    //    state : {id :"newlead"}
    // });
    // : history.push(`/marketplace/view-lead/${item?.redirect_to_id}`);

    if (item?.notification_type == 14 && item?.sender_role == 6) {
      history.push({
        pathname: `/marketplace/dashboard`,
        search: `?id=${item?.post_id}&tab=dispute`,
      });
      localStorage.setItem("tab", "dispute");
    }

    if (item?.notification_type == 3) {
      history.push("/networking");
    }

    if (item?.notification_type === "15") {
      if (item?.sender_role === 11) {
        // history.push(`/marketplace/view-lead/${item?.redirect_to_id}`)

        history.push({
          pathname: `/marketplace/dashboard/`,
          search: `?id=${item?.redirect_to_id}&tab=newlead`,
          // state: { id: "redirect" }
        });
        localStorage.setItem("tab", "newlead");
        // history.push({
        //   pathname:`/marketplace/dashboard/?id=${item?.redirect_to_id}`,

        //   state:{id:"redirect"}
        // })
      }
      // } else if (item?.sender_role === 3) {
      //   dispatch(setMyDashboardStatus("myOrder"))
      //   history.push(`${'/marketplace/my-order-view/'}${item?.post_id}`);
      // }
    }

    if (parseInt(item?.notification_type) === 11) {
      setDeclineModal(true);
      setDeclineData(item);
    }

    if (item?.notification_type === "12") {
      if (item?.sender_role === 6) {
        // localStorage.setItem('tab', 'order-management');
        // history.push('/marketplace/dashboard');
        history.push({
          pathname: `/marketplace/dashboard/`,
          search: `?id=${item?.redirect_to_id}&tab=order-management`,
          // state: { id: "redirect" }
        });
        localStorage.setItem("tab", "order-management");
      } else if (item?.sender_role === 3) {
        dispatch(setMyDashboardStatus("myOrder"));
        history.push(`${"/marketplace/my-order-view/"}${item?.post_id}`);
      }
    }

    if (item?.notification_type === "13") {
      history.push(`${"/marketplace/offer/"}${item?.post_id}`);
    }

    // redirect to post screen
    // parseInt(item?.notification_type) === 10 && history.push(`${"/home/post/activity/"}${item?.post_id}`);
    parseInt(item?.notification_type) === 2 &&
      history.push(`${"/home/post/activity/"}${item?.post_id}`);
    parseInt(item?.notification_type) === 6 &&
      history.push(`${"/home/post/activity/"}${item?.post_id}`);
    parseInt(item?.notification_type) === 7 &&
      history.push(`${"/home/post/activity/"}${item?.post_id}`);
    parseInt(item?.notification_type) === 8 &&
      history.push(`${"/view-events/"}${item?.post_id}`);
    item?.notification_type === "added post" &&
      history.push(`${"/home/post/activity/"}${item?.post_id}`);
    item?.notification_type === "progress" &&
      item?.redirect_to === "membership_progress" &&
      history.push(`/membership`);
    if (parseInt(item?.notification_type) === 10) {
      if (
        user?.role_id === constant?.rolesId?.restaurant ||
        user?.role_id === constant?.rolesId?.importer ||
        user?.role_id === constant?.rolesId?.distributer ||
        user?.role_id === constant?.rolesId?.["importer&distributer"] ||
        user?.role_id === constant?.rolesId?.voiceOfExpert
      ) {
        parseInt(item?.notification_type) === 10 &&
          history.push({
            pathname: "/marketplace/inquiry",
            state: item?.enquiry_type,
          });
      } else {
        parseInt(item?.notification_type) === 10 &&
          history.push({
            pathname: "/marketplace/dashboard",
            state: item?.enquiry_type,
          });
      }
    }

    SetShowNotif(!showNotif);
  };

  let authenticUser =
    (alyseiReview === "false" || alyseiReview === false) &&
    parseInt(localStorage.getItem("alysei_review")) != 1 &&
    user &&
    user.role_id !== constant.rolesId.voyagers;

  return (
    <Fragment>
      {/* header */}
      <div className="site__header">
        <div className="site__width">
          <div className="site-align">
            <div className="top_left-header site-align">
              <div className="site__logo header">
                {/* <img src={"../../../assets/images/logo.png"} alt="" /> */}
                <Link to="/home">
                  <img src={logo} alt="" />{" "}
                </Link>
              </div>
            </div>
            <div className="site_menu desktop__view">
              <ul className="main_menu-list">
                <li className="menu-list-item home-icon">
                  <Link
                    to="/home"
                    className={
                      location.pathname.includes("home")
                        ? "home-nav Active"
                        : "home-nav"
                    }
                    title="Home"
                  >
                    <span className="disable_icon">
                      <img src={homedisable} alt="Home" />
                    </span>
                    <span className="enable_icon">
                      <img src={homeactive} alt="Home" />
                    </span>
                    {/* <span className="header__title">Home</span> */}
                  </Link>
                </li>
                {user && user.role_id !== constant.rolesId.voyagers && (
                  <li className="menu-list-item">
                    <Link
                      to="/membership"
                      className={
                        location.pathname === "/membership"
                          ? "user-nav Active"
                          : "user-nav"
                      }
                      title="Membership"
                    >
                      <span className="disable_icon">
                        <img src={memberdisable} alt="Membership" />
                      </span>
                      <span className="enable_icon">
                        <img src={memberactive} alt="Membership" />
                      </span>
                      {/* <span className="header__title">Membership</span> */}
                    </Link>
                  </li>
                )}
                <li
                  className={
                    authenticUser ||
                    parseInt(localStorage.getItem("profile_percentage")) != 100
                      ? "menu-list-item cursorDisable "
                      : "menu-list-item "
                  }
                >
                  <Link
                    to="/networking"
                    className={
                      location.pathname.includes("networking") ||
                      location.pathname.includes("pending") ||
                      location.pathname.includes("following") ||
                      location.pathname.includes("connection")
                        ? "network-nav Active"
                        : "network-nav"
                    }
                    title="Networking"
                  >
                    <span className="disable_icon">
                      <img src={networkdisable} alt="Networking" />
                    </span>
                    <span className="enable_icon">
                      <img src={networkactive} alt="Networking" />
                    </span>
                    {/* <span className="header__title">Networking</span> */}
                  </Link>
                </li>
                <li
                  className={
                    authenticUser ||
                    parseInt(localStorage.getItem("profile_percentage")) != 100
                      ? "menu-list-item cursorDisable "
                      : "menu-list-item "
                  }
                >
                  <Link
                    to="/b2b"
                    className={
                      location.pathname.includes("b2b") ||
                      location.pathname.includes("viewhub") ||
                      location.pathname.includes("hubmember")
                        ? "b2b-nav Active"
                        : "b2b-nav"
                    }
                    title={b2bTitle}
                  >
                    <span className="disable_icon">
                      <img src={b2bdisable} alt="B2B" />
                    </span>
                    <span className="enable_icon">
                      <img src={b2bactive} alt="B2B" />
                    </span>
                    {/* <span className="header__title">B2B</span> */}
                  </Link>
                </li>
                <li
                  className={
                    parseInt(localStorage.getItem("profile_percentage")) === 100
                      ? "menu-list-item "
                      : "menu-list-item cursorDisable "
                  }
                >
                  <Link
                    to="/recipes"
                    className={
                      location.pathname.includes("recipe")
                        ? "book-nav Active"
                        : "book-nav"
                    }
                    title="Recipe"
                  >
                    <span className="disable_icon">
                      {" "}
                      <img src={recipedisable} alt="Recipes" />{" "}
                    </span>
                    <span className="enable_icon">
                      {" "}
                      <img src={recipeactive} alt="Recipes" />{" "}
                    </span>
                    {/* <span className="header__title">Recipes</span> */}
                  </Link>
                </li>
                <li
                  className={
                    parseInt(localStorage.getItem("profile_percentage")) === 100
                      ? "menu-list-item "
                      : "menu-list-item cursorDisable "
                  }
                >
                  <Link
                    to="/marketplace"
                    className={
                      location.pathname.includes("marketplace")
                        ? "store-nav Active"
                        : "store-nav"
                    }
                    title="Store"
                  >
                    <span className="disable_icon">
                      <img src={marketplacedisable} alt="Marketplace" />
                    </span>
                    <span className="enable_icon">
                      <img src={marketplaceactive} alt="Marketplace" />
                    </span>
                    {/* <span className="header__title">Marketplace</span> */}
                  </Link>
                </li>
              </ul>
            </div>

            <div className="min-menu site-align">
              {(alyseiReview === "false" || alyseiReview === false) &&
              parseInt(localStorage.getItem("alysei_review")) !== 1 &&
              user &&
              user.role_id !== constant.rolesId.voyagers ? (
                ""
              ) : (
                <div onClick={() => history.push("/universal/search")}>
                  <div className="site_search Desktop">
                    <form className="top-search hideMob">
                      <input
                        type="text"
                        placeholder={`${lang?.Search} Alysei`}
                      />
                      <button type="button">
                        <i className="fa fa-search" />
                      </button>
                    </form>
                  </div>
                  <div className="site_search Mobile">
                    <form className="top-search hideMob">
                      <button type="button">
                        <i className="fa fa-search" />
                      </button>
                    </form>
                  </div>
                </div>
              )}
              <div className="site_menu">
                <ul className="min_menu-list">
                  {(user.role_id === constant.rolesId.distributer ||
                    user.role_id === constant.rolesId["importer&distributer"] ||
                    user.role_id === constant.rolesId?.importer) && (
                    <li className="menu-list-item noti_list relative noti_Fy">
                      <Link to="/marketplace/my-cart">
                        {
                          <Fragment>
                            <svg
                              width="41"
                              height="41"
                              viewBox="0 0 41 41"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.70959 4.68566C4.55334 4.68346 4.39821 4.71232 4.25322 4.77059C4.10822 4.82885 3.97625 4.91535 3.86498 5.02506C3.75371 5.13477 3.66535 5.26551 3.60504 5.40966C3.54473 5.55382 3.51367 5.70853 3.51367 5.86479C3.51367 6.02105 3.54473 6.17576 3.60504 6.31991C3.66535 6.46407 3.75371 6.5948 3.86498 6.70451C3.97625 6.81423 4.10822 6.90073 4.25322 6.95899C4.39821 7.01726 4.55334 7.04612 4.70959 7.04391H6.87592C7.44814 7.04391 7.92513 7.43925 8.03355 8.00195L8.26846 9.23021L10.8033 22.5429C11.2616 24.9448 13.3778 26.696 15.8238 26.696H30.5413C32.9872 26.696 35.1043 24.9455 35.5618 22.5429L38.0966 9.23021C38.1291 9.05975 38.1236 8.88423 38.0805 8.71615C38.0374 8.54807 37.9577 8.39158 37.8471 8.25784C37.7365 8.1241 37.5978 8.01642 37.4408 7.94246C37.2839 7.8685 37.1125 7.8301 36.939 7.83H10.401L10.3503 7.56132C10.0335 5.90058 8.56687 4.68566 6.87592 4.68566H4.70959ZM10.8509 10.1882H35.5142L33.245 22.1023C32.9966 23.4069 31.8702 24.3377 30.5413 24.3377H15.8238C14.4954 24.3377 13.3697 23.4069 13.1201 22.1023V22.1008L10.8509 10.1882ZM17.68 28.2682C17.0545 28.2682 16.4547 28.5166 16.0124 28.9589C15.5702 29.4011 15.3217 30.0009 15.3217 30.6264C15.3217 31.2518 15.5702 31.8517 16.0124 32.2939C16.4547 32.7362 17.0545 32.9846 17.68 32.9846C18.3054 32.9846 18.9052 32.7362 19.3475 32.2939C19.7897 31.8517 20.0382 31.2518 20.0382 30.6264C20.0382 30.0009 19.7897 29.4011 19.3475 28.9589C18.9052 28.5166 18.3054 28.2682 17.68 28.2682ZM28.6851 28.2682C28.0597 28.2682 27.4598 28.5166 27.0176 28.9589C26.5753 29.4011 26.3269 30.0009 26.3269 30.6264C26.3269 31.2518 26.5753 31.8517 27.0176 32.2939C27.4598 32.7362 28.0597 32.9846 28.6851 32.9846C29.3106 32.9846 29.9104 32.7362 30.3526 32.2939C30.7949 31.8517 31.0434 31.2518 31.0434 30.6264C31.0434 30.0009 30.7949 29.4011 30.3526 28.9589C29.9104 28.5166 29.3106 28.2682 28.6851 28.2682Z"
                                fill="url(#paint0_linear_194_122)"
                              />
                              <defs>
                                <linearGradient
                                  id="paint0_linear_194_122"
                                  x1="20.8156"
                                  y1="4.68555"
                                  x2="20.8156"
                                  y2="32.9846"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stop-color="#33A386" />
                                  <stop offset="1" stop-color="#2F97C1" />
                                </linearGradient>
                              </defs>
                            </svg>

                            {/* <svg width="69px" height="69px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">

                        <g id="SVGRepo_bgCarrier" stroke-width="0"/>

                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>

                        <g id="SVGRepo_iconCarrier"> <path d="M3 6H22L19 16H6L3 6ZM3 6L2.25 3.5" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M9.99219 11H11.9922M13.9922 11H11.9922M11.9922 11V9M11.9922 11V13" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M11 19.5C11 20.3284 10.3284 21 9.5 21C8.67157 21 8 20.3284 8 19.5" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M17 19.5C17 20.3284 16.3284 21 15.5 21C14.6716 21 14 20.3284 14 19.5" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </g>

                        </svg> */}
                            {cartProducts?.length > 0 && (
                              <p className="noti_no">
                                {cartProducts?.length > 0 &&
                                  cartProducts?.length}
                              </p>
                            )}
                          </Fragment>
                        }
                      </Link>
                    </li>
                  )}

                  <li className="menu-list-item msg_list">
                    <Link
                      to="/message"
                      onClick={() => setRecentMessageCount(0)}
                    >
                      {recentMessageCount !== undefined &&
                        recentMessageCount !== 0 && (
                          <Fragment>
                            {recentMessageCount <= 10 && (
                              <p className="noti_no">{recentMessageCount}</p>
                            )}
                            {recentMessageCount > 10 && (
                              <p className="noti_no largeNotiNo">
                                10{" "}
                                <i
                                  className="fa fa-plus"
                                  aria-hidden="true"
                                ></i>
                              </p>
                            )}
                          </Fragment>
                        )}
                      <svg
                        width="26"
                        height="18"
                        viewBox="0 0 26 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M22.6832 -4.51588e-05H2.68315C2.0253 -0.00499048 1.39242 0.251546 0.923682 0.713151C0.454945 1.17476 0.188735 1.80363 0.183594 2.46148V14.7709C0.188735 15.4287 0.454945 16.0576 0.923682 16.5192C1.39242 16.9808 2.0253 17.2373 2.68315 17.2324H22.6832C23.009 17.235 23.3321 17.1733 23.6341 17.051C23.9361 16.9287 24.211 16.7481 24.4432 16.5195C24.6754 16.2909 24.8603 16.0189 24.9873 15.7188C25.1144 15.4188 25.181 15.0967 25.1836 14.7709V2.46148C25.181 2.13567 25.1144 1.81355 24.9873 1.51352C24.8603 1.21348 24.6754 0.941412 24.4432 0.712836C24.211 0.48426 23.9361 0.303658 23.6341 0.181341C23.3321 0.0590244 23.009 -0.00261055 22.6832 -4.51588e-05Z"
                          fill="url(#paint0_linear_693_835)"
                        />
                        <path
                          d="M25.1836 0.746506C25.1802 0.4905 25.1292 0.237358 25.0332 0L12.6832 8.09393L0.333956 0C0.237759 0.237293 0.186762 0.490475 0.183594 0.746506V1.29754L12.6832 9.49054L25.1827 1.29754L25.1836 0.746506Z"
                          fill="#C7E7FF"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_693_835"
                            x1="0.183594"
                            y1="-0.00012207"
                            x2="16.2885"
                            y2="23.3639"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#52E761" />
                            <stop offset="1" stopColor="#413CA6" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </Link>
                  </li>

                  <li
                    className="menu-list-item noti_list relative noti_Fy"
                    onClick={() => {
                      handleNotification();
                    }}
                  >
                    <Link to="#" ref={notificationRef}>
                      {notificationCount !== undefined &&
                        notificationCount !== 0 && (
                          <Fragment>
                            {notificationCount <= 10 && (
                              <p className="noti_no">{notificationCount}</p>
                            )}
                            {notificationCount > 10 && (
                              <p className="noti_no largeNotiNo">
                                10{" "}
                                <i
                                  className="fa fa-plus"
                                  aria-hidden="true"
                                ></i>
                              </p>
                            )}
                          </Fragment>
                        )}
                      <svg
                        width="30"
                        height="31"
                        viewBox="0 0 30 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.0937 20.1557C10.4731 20.1557 10.8439 20.2701 11.1594 20.4845C11.4748 20.6989 11.7207 21.0036 11.8659 21.3601C12.0111 21.7166 12.0491 22.1089 11.975 22.4873C11.901 22.8658 11.7183 23.2134 11.4501 23.4863C11.1818 23.7591 10.84 23.9449 10.4679 24.0202C10.0958 24.0955 9.71014 24.0569 9.35963 23.9092C9.00913 23.7615 8.70954 23.5115 8.49877 23.1906C8.28799 22.8698 8.17549 22.4926 8.17549 22.1067C8.17585 21.5894 8.37806 21.0933 8.73772 20.7275C9.09737 20.3617 9.58507 20.1561 10.0937 20.1557ZM10.0937 19.5058C9.58794 19.5058 9.09354 19.6584 8.67302 19.9442C8.2525 20.2299 7.92474 20.6361 7.7312 21.1114C7.53765 21.5866 7.48701 22.1096 7.58568 22.6141C7.68435 23.1186 7.92789 23.5821 8.28552 23.9458C8.64314 24.3095 9.09878 24.5573 9.59482 24.6576C10.0909 24.758 10.605 24.7065 11.0723 24.5096C11.5395 24.3127 11.9389 23.9794 12.2199 23.5517C12.5009 23.124 12.6508 22.6211 12.6508 22.1067C12.6508 21.7652 12.5847 21.4269 12.4562 21.1114C12.3277 20.7958 12.1393 20.5091 11.9019 20.2676C11.6644 20.0261 11.3825 19.8345 11.0723 19.7038C10.762 19.5731 10.4295 19.5058 10.0937 19.5058Z"
                          fill="#03A776"
                        />
                        <path
                          d="M1.04511 21.7826V19.8135C1.7483 19.7325 2.39759 19.3912 2.86919 18.8545C3.3408 18.3179 3.60174 17.6235 3.60226 16.9037V9.10381C3.60713 7.61993 4.08576 6.1778 4.96611 4.9945C5.84647 3.81121 7.0809 2.95078 8.4836 2.54273L8.71657 2.47622V1.95106C8.71657 1.51998 8.88493 1.10656 9.18463 0.801745C9.48432 0.496928 9.89079 0.325684 10.3146 0.325684C10.7384 0.325684 11.1449 0.496928 11.4446 0.801745C11.7443 1.10656 11.9127 1.51998 11.9127 1.95106V2.47345L12.1456 2.53996C13.5486 2.94808 14.7832 3.80871 15.6635 4.99229C16.5439 6.17586 17.0224 7.61831 17.027 9.10243V16.9051C17.0272 17.6249 17.288 18.3195 17.7597 18.8562C18.2314 19.3929 18.8808 19.7342 19.5841 19.8149V21.7839L1.04511 21.7826Z"
                          fill="#03A776"
                        />
                        <path
                          d="M10.3144 0.649873C10.6532 0.650239 10.978 0.787294 11.2176 1.03096C11.4572 1.27463 11.5919 1.60502 11.5923 1.94962V2.71727L12.0568 2.85584C13.3931 3.24466 14.569 4.06443 15.4076 5.19175C16.2462 6.31906 16.702 7.69292 16.7066 9.10653V16.905C16.7074 17.6543 16.9622 18.3804 17.428 18.9609C17.8938 19.5415 18.5421 19.9409 19.2637 20.092V21.4569H1.36367V20.092C2.08526 19.9409 2.73358 19.5415 3.19938 18.9609C3.66517 18.3804 3.91997 17.6543 3.92082 16.905V9.10237C3.92537 7.68876 4.38124 6.3149 5.21983 5.18759C6.05841 4.06027 7.23432 3.24051 8.57056 2.85168L9.03513 2.71311V1.951C9.03549 1.6064 9.17024 1.27602 9.40981 1.03235C9.64938 0.78868 9.97421 0.651625 10.313 0.651258L10.3144 0.649873ZM10.313 0.00138572C9.80428 0.00138572 9.31638 0.206937 8.95665 0.572821C8.59691 0.938705 8.39482 1.43495 8.39482 1.95239V2.22952C6.9236 2.65361 5.62846 3.55406 4.70578 4.79434C3.7831 6.03461 3.2832 7.54706 3.28188 9.10237V16.905C3.28188 17.5948 3.01246 18.2563 2.5329 18.7441C2.05334 19.2319 1.40292 19.5059 0.724724 19.5059V22.1068H19.9027V19.5059C19.2245 19.5059 18.5741 19.2319 18.0945 18.7441C17.6149 18.2563 17.3455 17.5948 17.3455 16.905V9.10237C17.3447 7.54641 16.8449 6.03319 15.9219 4.79233C14.9989 3.55147 13.7031 2.65072 12.2312 2.22675V1.94962C12.2309 1.43266 12.0288 0.93698 11.6694 0.571435C11.31 0.205891 10.8226 0.000367028 10.3144 0L10.313 0.00138572Z"
                          fill="#03A776"
                        />
                      </svg>
                    </Link>
                  </li>

                  <li className="menu-list-item profile_list">
                    <div
                      onClick={() => {
                        SetShowNotif(false);
                        SetshowProfile(!showProfile);
                      }}
                      ref={profilePopUpRef}
                    >
                      <Link className="site-align" to="#">
                        <span
                          className="user_profile-pic"
                          style={{
                            border: `${"0.125rem solid"}#${
                              profileData?.data?.user_data?.profile_color
                            }`,
                          }}
                        >
                          <img
                            src={
                              profileData?.data?.user_data?.avatar_id
                                ?.base_url !== undefined
                                ? `${profileData?.data?.user_data?.avatar_id?.base_url}${profileData?.data?.user_data?.avatar_id?.attachment_large_url}`
                                : userProfile
                            }
                          />
                        </span>
                        <span className="user_profile-name">
                          {profileData?.data?.user_data?.company_name ??
                            profileData?.data?.user_data?.restaurant_name}
                        </span>
                      </Link>
                    </div>
                    {showProfile ? (
                      <div>
                        <div
                          className="user_profile-drop"
                          style={{ paddingTop: 20 }}
                        >
                          <div className="user_profile-pic">
                            {/* <img src={userProfile} /> */}
                            <img
                              src={
                                profileData?.data?.user_data?.avatar_id !== null
                                  ? `${profileData?.data?.user_data?.avatar_id?.base_url}${profileData?.data?.user_data?.avatar_id?.attachment_large_url}`
                                  : userProfile
                              }
                            />
                          </div>
                          <div className="user_profile-name">
                            <span>
                              <Link to="/profile">
                                {profileData?.data?.user_data?.company_name ??
                                  profileData?.data?.user_data?.restaurant_name}
                              </Link>
                            </span>
                            {profileData && profileData.data
                              ? profileData.data.user_data.username
                              : ""}
                          </div>
                        </div>
                        <ul className="user__profile-options">
                          <li className="profile_list icon">
                            <Link to="/profile">
                              <span>
                                <img
                                  className="subProfileImg"
                                  src={
                                    profileData?.data?.user_data?.avatar_id !==
                                    null
                                      ? `${profileData?.data?.user_data?.avatar_id?.base_url}${profileData?.data?.user_data?.avatar_id?.attachment_large_url}`
                                      : userProfile
                                  }
                                />{" "}
                                &nbsp; &nbsp; {lang?.only_profile}
                              </span>
                            </Link>
                          </li>
                          <li className="profile_list icon">
                            <Link to="/setting">
                              <span>
                                <svg
                                  width="27"
                                  height="27"
                                  viewBox="0 0 24 23"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M22.634 9.37872L20.2883 8.77544C20.1691 8.44402 20.0282 8.12012 19.8665 7.80567L20.9847 5.89328C21.1874 5.55607 21.2684 5.16421 21.2152 4.7784C21.162 4.39259 20.9775 4.03435 20.6904 3.75918L20.0805 3.17475C19.7934 2.89956 19.4196 2.72278 19.017 2.6718C18.6144 2.62081 18.2055 2.69846 17.8536 2.89272L15.8581 3.9643C15.53 3.80932 15.192 3.67432 14.8462 3.5601L14.2167 1.31213C14.1116 0.935675 13.8798 0.602986 13.5573 0.365722C13.2347 0.128459 12.8394 -0.000102857 12.4328 6.17454e-08H11.5672C11.1613 5.09783e-05 10.7667 0.128331 10.4445 0.364985C10.1223 0.601638 9.89047 0.933469 9.78492 1.30911L9.15541 3.55708C8.80954 3.67123 8.47156 3.80623 8.14348 3.96128L6.14715 2.89046C5.79527 2.6962 5.38638 2.61855 4.98379 2.66953C4.58121 2.72052 4.2074 2.8973 3.92026 3.17249L3.31043 3.75692C3.02315 4.03202 2.8386 4.39027 2.7854 4.77611C2.73219 5.16195 2.81329 5.55384 3.01613 5.89102L4.13429 7.80341C3.97259 8.11785 3.83172 8.44175 3.71252 8.77318L1.36603 9.37646C0.973924 9.47765 0.62757 9.69991 0.380614 10.0088C0.133658 10.3178 -0.000119861 10.6961 8.05815e-08 11.0852V11.9148C5.32109e-05 12.3038 0.133911 12.6819 0.380853 12.9907C0.627796 13.2995 0.974054 13.5216 1.36603 13.6228L3.71174 14.2261C3.83085 14.5575 3.97172 14.8814 4.13351 15.1958L3.01613 17.109C2.81342 17.4462 2.7324 17.8381 2.7856 18.2239C2.8388 18.6097 3.02327 18.9679 3.31043 19.2431L3.92026 19.8275C4.20733 20.1028 4.58115 20.2797 4.98377 20.3307C5.38638 20.3817 5.79531 20.3039 6.14715 20.1095L8.14269 19.038C8.4708 19.1929 8.80879 19.3279 9.15462 19.4422L9.78413 21.6901C9.88957 22.066 10.1214 22.3981 10.4438 22.6349C10.7662 22.8718 11.161 23.0001 11.5672 23H12.4328C12.8387 22.9999 13.2333 22.8717 13.5555 22.635C13.8777 22.3984 14.1095 22.0665 14.2151 21.6909L14.8446 19.4429C15.1905 19.3288 15.5284 19.1938 15.8565 19.0387L17.8521 20.1103C18.2039 20.3046 18.6128 20.3822 19.0154 20.3312C19.418 20.2802 19.7918 20.1035 20.079 19.8283L20.6888 19.2438C20.9759 18.9687 21.1604 18.6104 21.2136 18.2246C21.2668 17.8388 21.1858 17.4469 20.9831 17.1097L19.8649 15.1973C20.0266 14.8829 20.1675 14.559 20.2867 14.2276L22.6324 13.6243C23.0249 13.5234 23.3717 13.3011 23.619 12.992C23.8663 12.6829 24.0002 12.3042 24 11.9148V11.0852C23.9997 10.6964 23.8658 10.3186 23.6188 10.0101C23.3719 9.70159 23.0258 9.47969 22.634 9.37872Z"
                                    fill="url(#paint0_linear_526_8319)"
                                  />
                                  <path
                                    d="M11.9998 7.07715C11.0871 7.07715 10.1948 7.33654 9.43585 7.82252C8.6769 8.3085 8.08538 8.99925 7.73607 9.80741C7.38677 10.6156 7.29537 11.5048 7.47344 12.3628C7.65152 13.2207 8.09106 14.0088 8.73649 14.6273C9.38192 15.2459 10.2043 15.6671 11.0995 15.8377C11.9947 16.0084 12.9227 15.9208 13.766 15.5861C14.6093 15.2513 15.33 14.6844 15.8371 13.9571C16.3443 13.2298 16.6149 12.3747 16.6149 11.4999C16.6149 10.3269 16.1287 9.20199 15.2632 8.37255C14.3977 7.54312 13.2238 7.07715 11.9998 7.07715Z"
                                    fill="url(#paint1_linear_526_8319)"
                                  />
                                  <path
                                    d="M12.0003 9.73096C11.6352 9.73096 11.2783 9.83471 10.9747 10.0291C10.6712 10.2235 10.4345 10.4998 10.2948 10.8231C10.1551 11.1463 10.1185 11.502 10.1898 11.8452C10.261 12.1884 10.4368 12.5036 10.695 12.751C10.9532 12.9984 11.2821 13.1669 11.6402 13.2352C11.9983 13.3035 12.3695 13.2684 12.7068 13.1345C13.0441 13.0006 13.3324 12.7739 13.5352 12.4829C13.7381 12.192 13.8464 11.85 13.8464 11.5001C13.8464 11.0309 13.6519 10.5809 13.3057 10.2491C12.9595 9.91735 12.4899 9.73096 12.0003 9.73096Z"
                                    fill="white"
                                  />
                                  <defs>
                                    <linearGradient
                                      id="paint0_linear_526_8319"
                                      x1="0"
                                      y1="0"
                                      x2="23.6436"
                                      y2="11.1516"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stopColor="#8160FE" />
                                      <stop offset="1" stopColor="#44DBDC" />
                                    </linearGradient>
                                    <linearGradient
                                      id="paint1_linear_526_8319"
                                      x1="7.38477"
                                      y1="7.07715"
                                      x2="16.5804"
                                      y2="9.0922"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stopColor="#05B3D3" />
                                      <stop offset="1" stopColor="#C081D3" />
                                    </linearGradient>
                                  </defs>
                                </svg>{" "}
                                &nbsp; &nbsp; {lang?.Settings} &amp;{" "}
                                {lang?.Privacy}
                              </span>
                            </Link>
                          </li>
                          <li className="profile_list icon">
                            <Link to="#" onClick={() => logout()}>
                              <span>
                                <svg
                                  width="27"
                                  height="27"
                                  viewBox="0 0 24 25"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clipPath="url(#clip0_520_7369)">
                                    <path
                                      d="M15.3844 25H2.88443C2.11943 25 1.38576 24.6961 0.844829 24.1552C0.303894 23.6142 0 22.8806 0 22.1156V2.88443C0 2.11943 0.303894 1.38576 0.844829 0.844829C1.38576 0.303894 2.11943 0 2.88443 0H15.3844C16.1494 0 16.8831 0.303894 17.424 0.844829C17.965 1.38576 18.2689 2.11943 18.2689 2.88443V22.1156C18.2689 22.8806 17.965 23.6142 17.424 24.1552C16.8831 24.6961 16.1494 25 15.3844 25Z"
                                      fill="url(#paint0_linear_520_7369)"
                                    />
                                    <path
                                      d="M16.3453 7.74535V11.0585H8.17232C7.98003 11.0539 7.78877 11.0878 7.60978 11.1582C7.43079 11.2286 7.2677 11.3341 7.13008 11.4685C6.99246 11.6029 6.8831 11.7634 6.80844 11.9407C6.73378 12.1179 6.69531 12.3083 6.69531 12.5007C6.69531 12.693 6.73378 12.8834 6.80844 13.0607C6.8831 13.2379 6.99246 13.3985 7.13008 13.5329C7.2677 13.6672 7.43079 13.7727 7.60978 13.8431C7.78877 13.9136 7.98003 13.9475 8.17232 13.9429H16.3453V17.256C16.3349 17.4468 16.3821 17.6362 16.4809 17.7998C16.5797 17.9633 16.7254 18.0933 16.8991 18.1729C17.0727 18.2525 17.2663 18.2779 17.4547 18.246C17.643 18.214 17.8174 18.1261 17.9551 17.9937L22.7723 13.2396C22.967 13.0426 23.0762 12.7768 23.0762 12.4999C23.0762 12.2229 22.967 11.9571 22.7723 11.7601L17.9551 7.00601C17.8173 6.87346 17.6428 6.7855 17.4543 6.75359C17.2657 6.72167 17.072 6.74728 16.8982 6.82708C16.7245 6.90688 16.5788 7.03716 16.4802 7.20096C16.3815 7.36475 16.3345 7.55446 16.3453 7.74535Z"
                                      fill="url(#paint1_linear_520_7369)"
                                    />
                                    <path
                                      d="M2.96356 13.934C3.86895 13.934 4.60291 13.2 4.60291 12.2946C4.60291 11.3892 3.86895 10.6553 2.96356 10.6553C2.05818 10.6553 1.32422 11.3892 1.32422 12.2946C1.32422 13.2 2.05818 13.934 2.96356 13.934Z"
                                      fill="white"
                                    />
                                  </g>
                                  <defs>
                                    <linearGradient
                                      id="paint0_linear_520_7369"
                                      x1="0"
                                      y1="0"
                                      x2="18.2825"
                                      y2="0.534399"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stopColor="#202D8A" />
                                      <stop offset="1" stopColor="#4373D4" />
                                    </linearGradient>
                                    <linearGradient
                                      id="paint1_linear_520_7369"
                                      x1="6.69531"
                                      y1="6.74023"
                                      x2="9.49875"
                                      y2="18.8576"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stopColor="#F51B21" />
                                      <stop offset="1" stopColor="#EC930D" />
                                    </linearGradient>
                                    <clipPath id="clip0_520_7369">
                                      <rect
                                        width="23.077"
                                        height="25"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                                &nbsp; &nbsp; {lang?.Logout}
                              </span>
                            </Link>
                          </li>
                        </ul>
                        {/* <div className="logout_button">
                          <a href="/register" onClick={() => logout()}>
                            Logout
                          </a>
                        </div> */}
                      </div>
                    ) : null}

                    {/* {showNotif && (
                      <div className="card card--block modal_box notification">
                        <div className="flex justify-between items-center mb-3">
                          <h4 className="page__title">Notifications</h4>
                        </div>
                        {getNotificationSpinner ? (
                          <FormSpinner />
                        ) : (
                          <Fragment>
                            <div className="flex justify-between items-center mb-3">
                              <div className="leftBlockTitle">
                                <h4 className="font-size-18 text-black font-bold">
                                  Earlier
                                </h4>
                              </div>
                              <div className="rightBlockLink just__Now">
                                <Link
                                  to="#"
                                  onClick={() => removeNotification()}
                                >
                                  Clear All
                                </Link>
                              </div>
                            </div>
                            {notificationData &&
                              notificationData.data &&
                              notificationData.data.map((item, index) => {
                                return (
                                  <Fragment key={index}>
                                    <div className="feed-user-info home_page noti mb-1">
                                      <div className="user__pic">
                                        {item && item.user ? (
                                          <img
                                            src={`${item.user.base_url}${item.user.avatar_image}`}
                                            alt="Profile image"
                                          />
                                        ) : (
                                          <img
                                            src="https://source.unsplash.com/user/c_v_r"
                                            alt="Profile image"
                                          />
                                        )}
                                      </div>

                                      <div className="user__detail-data">
                                        <span className="user__name">
                                          <strong>{item.sender_name}</strong>
                                        </span>
                                        <span className="user__name">
                                          {item.title}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="just__Now text-right">
                                      <a href="javascript:void(0)">Just Now</a>
                                    </div>
                                    <hr />
                                  </Fragment>
                                );
                              })}
                          </Fragment>
                        )}
                      </div>
                    )} */}
                  </li>
                </ul>
              </div>
            </div>

            <div className="headerView mobile__view">
              <Menu>
                {/* <button className="text-2xl leading-none focus:outline-none">
                <i className="fas fa-bars" />
              </button> */}
                <ul className="main_menu-list">
                  <li className="menu-list-item home-icon">
                    <Link
                      to="/home"
                      className={
                        location.pathname === "/home"
                          ? "home-nav Active"
                          : "home-nav"
                      }
                      title="Home"
                    >
                      <span className="disable_icon">
                        <img src={homedisable} alt="Home" />
                      </span>
                      <span className="enable_icon">
                        <img src={homeactive} alt="Home" />
                      </span>
                      <span className="header__title">{lang?.only_home}</span>
                    </Link>
                  </li>
                  <li className="menu-list-item">
                    <Link
                      to="/membership"
                      className={
                        location.pathname === "/membership"
                          ? "user-nav Active"
                          : "user-nav"
                      }
                      title="Membership"
                    >
                      <span className="disable_icon">
                        <img src={memberdisable} alt="Membership" />
                      </span>
                      <span className="enable_icon">
                        <img src={memberactive} alt="Membership" />
                      </span>
                      <span className="header__title">{lang?.Membership}</span>
                    </Link>
                  </li>
                  <li
                    className={
                      authenticUser
                        ? "menu-list-item cursorDisable "
                        : "menu-list-item "
                    }
                  >
                    <Link
                      to="/networking"
                      className={
                        location.pathname.includes("networking") ||
                        location.pathname.includes("pending") ||
                        location.pathname.includes("following") ||
                        location.pathname.includes("connection")
                          ? "network-nav Active"
                          : "network-nav"
                      }
                      title="Networking"
                    >
                      <span className="disable_icon">
                        <img src={networkdisable} alt="Networking" />
                      </span>
                      <span className="enable_icon">
                        <img src={networkactive} alt="Networking" />
                      </span>
                      <span className="header__title">{lang?.Networking}</span>
                    </Link>
                  </li>
                  <li
                    className={
                      authenticUser
                        ? "menu-list-item cursorDisable "
                        : "menu-list-item "
                    }
                  >
                    <Link
                      to="/b2b"
                      className={
                        location.pathname.includes("b2b") ||
                        location.pathname.includes("viewhub") ||
                        location.pathname.includes("hubmember")
                          ? "b2b-nav Active"
                          : "b2b-nav"
                      }
                      title="B2B"
                    >
                      <span className="disable_icon">
                        <img src={b2bdisable} alt="B2B" />
                      </span>
                      <span className="enable_icon">
                        <img src={b2bactive} alt="B2B" />
                      </span>
                      <span className="header__title">{lang?.B2B}</span>
                    </Link>
                  </li>
                  <li
                    className={
                      parseInt(localStorage.getItem("profile_percentage")) ===
                      100
                        ? "menu-list-item "
                        : "menu-list-item cursorDisable "
                    }
                  >
                    <Link
                      to="/recipes"
                      className={
                        location.pathname.includes("recipe")
                          ? "book-nav Active"
                          : "book-nav"
                      }
                      title="Recipe"
                    >
                      <span className="disable_icon">
                        {" "}
                        <img src={recipedisable} alt="Recipes" />{" "}
                      </span>
                      <span className="enable_icon">
                        {" "}
                        <img src={recipeactive} alt="Recipes" />{" "}
                      </span>
                      <span className="header__title">{lang?.Recipes}</span>
                    </Link>
                  </li>
                  <li
                    className={
                      parseInt(localStorage.getItem("profile_percentage")) ===
                      100
                        ? "menu-list-item "
                        : "menu-list-item cursorDisable "
                    }
                  >
                    <Link
                      to="/marketplace"
                      className={
                        location.pathname.includes("marketplace")
                          ? "store-nav Active"
                          : "store-nav"
                      }
                      title="Store"
                    >
                      <span className="disable_icon">
                        <img src={marketplacedisable} alt="Marketplace" />
                      </span>
                      <span className="enable_icon">
                        <img src={marketplaceactive} alt="Marketplace" />
                      </span>
                      <span className="header__title">
                        {lang?.only_Marketplace}
                      </span>
                    </Link>
                  </li>
                </ul>
                <div className="mobileFooter">
                  <RightFooter />
                </div>
              </Menu>
            </div>
          </div>

          {showNotif && (
            <div className="card card--block modal_box notification">
              <div className="flex justify-between items-center mb-3 notification-header">
                <h4 className="page__title">{lang?.Notifications}</h4>
                <Link to="#" onClick={() => removeNotification()}>
                  {" "}
                  {lang?.Clear_All}
                </Link>
              </div>

              <div className="notification--scroll">
                {getNotificationSpinner ? (
                  <FormSpinner />
                ) : (
                  <Fragment>
                    {notificationData &&
                    notificationData.data &&
                    notificationData.data.length > 0 ? (
                      notificationData.data.map((item, index) => {
                        return (
                          <Fragment key={index}>
                            <div className="feed-user-info home_page noti mb-1">
                              <div
                                className="user__pic"
                                onClick={() => redirectTo(item)}
                              >
                                {item && item.user ? (
                                  <img
                                    src={`${item.user.base_url}${item.user.avatar_image}`}
                                    alt="Profile image"
                                  />
                                ) : (
                                  <img
                                    src="https://source.unsplash.com/user/c_v_r"
                                    alt="Profile image"
                                  />
                                )}
                              </div>

                              <div className="user__detail-data w-full tested">
                                <div className="flex">
                                  <span
                                    className="user__name"
                                    onClick={() => redirectTo(item)}
                                  >
                                    <Link to="#">
                                      <strong>{item.sender_name}</strong>
                                    </Link>
                                  </span>
                                </div>
                                <span className="user__name">{item.title}</span>
                                <div className="just__Now text-right">
                                  {item?.posted_at}
                                </div>
                              </div>
                            </div>
                            <hr />
                          </Fragment>
                        );
                      })
                    ) : (
                      <div className="empty_notification">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="m-auto"
                          width="63.185"
                          height="67.363"
                          viewBox="0 0 63.185 67.363"
                        >
                          <path
                            id="icons8_notification_2"
                            d="M36.205,4a3.6,3.6,0,0,0-3.228,1.992L31.361,9.23A18.071,18.071,0,0,0,17.245,24.619l-2.613,20.92A10.846,10.846,0,0,1,12.9,50.2L7.345,58.535a3.608,3.608,0,0,0,3,5.611H30a8.412,8.412,0,0,0,16.653,0h19.66a3.612,3.612,0,0,0,3-5.611L63.76,50.2a10.846,10.846,0,0,1-1.734-4.661l-2.613-20.92A18.07,18.07,0,0,0,45.3,9.23L43.681,5.992A3.6,3.6,0,0,0,40.453,4Zm0,2.406h4.248a1.186,1.186,0,0,1,1.071.667l.893,1.781c-.305-.014-.6-.042-.912-.042H35.153c-.305,0-.606.028-.912.042l.893-1.781A1.185,1.185,0,0,1,36.205,6.406Zm-1.053,4.812h6.353a15.66,15.66,0,0,1,15.516,13.7l2.617,20.924a13.272,13.272,0,0,0,2.119,5.695l5.554,8.331a1.2,1.2,0,0,1-1,1.875H10.343a1.2,1.2,0,0,1-1-1.87l5.169-7.753H48.155a1.2,1.2,0,0,0,0-2.406H15.892a13.288,13.288,0,0,0,1.128-3.872l2.612-20.924A15.665,15.665,0,0,1,35.153,11.217Zm5.432,3.609a1.2,1.2,0,0,0,0,2.406,9.323,9.323,0,0,1,5.944,2.138,1.2,1.2,0,1,0,1.537-1.856A11.764,11.764,0,0,0,40.585,14.826Zm9.572,6.2a1.157,1.157,0,0,0-.46.108,1.2,1.2,0,0,0-.6,1.588,9.339,9.339,0,0,1,.785,3.035,1.2,1.2,0,0,0,1.2,1.095.762.762,0,0,0,.1,0,1.2,1.2,0,0,0,1.095-1.306,11.681,11.681,0,0,0-.992-3.806A1.208,1.208,0,0,0,50.156,21.029Zm2.509,28.682a1.2,1.2,0,0,0,0,2.406h5.112a1.2,1.2,0,0,0,0-2.406ZM14.271,54.522a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,14.271,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,20.285,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,26.3,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,1,0,2.406,0V55.725A1.205,1.205,0,0,0,32.315,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,38.329,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,44.344,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,50.358,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,56.373,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,62.388,54.522ZM32.437,64.146H44.222a6.014,6.014,0,0,1-11.785,0Z"
                            transform="translate(-6.737 -4)"
                          />
                        </svg>
                        <h4 className="font-18 text-black">
                          {lang?.no_notifications}
                        </h4>
                      </div>
                    )}
                    {notificationData?.total > 10 && (
                      <div className="just__Now viewAll">
                        <Link to="/notification" className="btn">
                          {lang?.View_all} {lang?.Notifications}
                        </Link>
                      </div>
                    )}
                  </Fragment>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Decline modal */}
      {declineModal && (
        <Modal
          isOpen={declineModal}
          style={{
            overlay: {
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.75)",
            },
            content: {
              position: "absolute",
              top: "0",
              left: "0%",
              right: "0%",
              bottom: "200px",
              border: "1px solid #ccc",
              background: "#fff",
              overflow: "auto",
              WebkitOverflowScrolling: "touch",
              borderRadius: "4px",
              padding: "0",
              // outline: 'none',
            },
          }}
        >
          <div className="popup_header flex justify-between items-center">
            <h4 className="page__title">{lang?.Reason_to_Decline}</h4>
            <button
              className="close_btn--modal"
              onClick={() => setDeclineModal(!declineModal)}
            >
              {lang?.close}
            </button>
          </div>
          <div className="card card--block modal_box modalLessGap">
            {/* <h4 className='font-16 mb-2'> {lang?.Sending_a_request_to} {removeConnection ? openModelData?.from : `${lang?.connect_with}`}  <strong>@{openModelData.name}
          </strong></h4> */}
            {/* <p style={{ color: "red" }}>{errorText}</p> */}
            <p className="font-16 mb-2">{declineData?.sender_name}</p>
            <p className="font-14 mb-2">{declineData?.reason}</p>
            {/* <form>
              <textarea className="write_post-area w-full" rows="2" value={declineData?.title}
                // onChange={(e) => setConnectText(e.target.value)}
                disabled
              />
            </form> */}
            {/* <div className="view__hub__btn">
              <button type="button" className="btn btnTeal" onClick={() => setDeclineModal(!declineModal)}>Cancel </button>
            </div> */}
          </div>
          <div></div>
        </Modal>
      )}
    </Fragment>
  );
}
